import React, { useEffect, useState } from 'react';
import { Layout, Card, Typography, Spin, Alert, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import logo from "../assets/images/logo.png";

const { Content } = Layout;
const { Title, Text } = Typography;

const PdfViewerPage = ({ pdfPath, titleKey }) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const localizedPdfPath = pdfPath.replace('.pdf', `-${currentLang}.pdf`);
  const fallbackPdfPath = pdfPath.replace('.pdf', '-en.pdf');
  const [effectivePdfPath, setEffectivePdfPath] = useState(localizedPdfPath);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setLoadError(false);

    // Try localized version first
    fetch(localizedPdfPath, { method: 'HEAD' })
      .then((response) => {
        if (!cancelled) {
          if (response.ok) {
            setEffectivePdfPath(localizedPdfPath);
            setLoadError(false);
          } else {
            // Try fallback English version
            fetch(fallbackPdfPath, { method: 'HEAD' })
              .then((fallbackResponse) => {
                if (!cancelled) {
                  if (fallbackResponse.ok) {
                    setEffectivePdfPath(fallbackPdfPath);
                    setLoadError(false);
                  } else {
                    setLoadError(true);
                  }
                  setLoading(false);
                }
              })
              .catch(() => {
                if (!cancelled) {
                  setLoadError(true);
                  setLoading(false);
                }
              });
          }
          if (response.ok && !cancelled) {
            setLoading(false);
          }
        }
      })
      .catch(() => {
        if (!cancelled) {
          // Try fallback English version
          fetch(fallbackPdfPath, { method: 'HEAD' })
            .then((fallbackResponse) => {
              if (!cancelled) {
                if (fallbackResponse.ok) {
                  setEffectivePdfPath(fallbackPdfPath);
                  setLoadError(false);
                } else {
                  setLoadError(true);
                }
                setLoading(false);
              }
            })
            .catch(() => {
              if (!cancelled) {
                setEffectivePdfPath(pdfPath);
                setLoadError(false);
                setLoading(false);
              }
            });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [localizedPdfPath, fallbackPdfPath]);

  return (
    <Layout className="layout-default layout-static-page">
      <Content className="p-0">
        <div className="page-header" style={{ padding: '24px 24px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Title level={2} style={{ margin: 0 }}>{t(titleKey)}</Title>
          <img src={logo} alt="Castrum eSIM Dashboard" style={{ height: '50px' }} />
        </div>

        <Card bordered={false} style={{ margin: '0 24px 24px' }}>
          {loading && (
            <div style={{ textAlign: 'center', minHeight: '60vh', padding: '40px 0' }}>
              <Spin tip={t('pdfViewer.loading')} />
            </div>
          )}

          {!loading && loadError && (
            <Alert
              type="error"
              showIcon
              message={t('pdfViewer.loadError')}
              description={
                <div>
                  <Text>{t('pdfViewer.missingDocument')}</Text>
                  <div style={{ marginTop: 12 }}>
                    <Button type="primary" href={localizedPdfPath} target="_blank" rel="noopener noreferrer">
                      {t('pdfViewer.openInNewTab')}
                    </Button>
                  </div>
                </div>
              }
            />
          )}

          {!loading && !loadError && (
            <div style={{ minHeight: '70vh' }}>
              {/*<div style={{ marginBottom: 16 }}>
                <Button type="primary" href={pdfPath} target="_blank" rel="noopener noreferrer">
                  {t('pdfViewer.openInNewTab')}
                </Button>
              </div>*/}
              <object
                data={effectivePdfPath}
                type="application/pdf"
                width="100%"
                height="75vh"
                style={{height: '85vh',  width: '100%' }}
                aria-label={t(titleKey)}
              >
                <div style={{ padding: 24, textAlign: 'center' }}>
                  <Text>{t('pdfViewer.loadError')}</Text>
                  <div style={{ marginTop: 12 }}>
                    <Button type="primary" href={effectivePdfPath} target="_blank" rel="noopener noreferrer">
                      {t('pdfViewer.openInNewTab')}
                    </Button>
                  </div>
                </div>
              </object>
            </div>
          )}
        </Card>
      </Content>
    </Layout>
  );
};

export default PdfViewerPage;
